import request from '@/api/request'
/**
 * 名师列表
 * @param page
 * @param limit
 */
export const getTeacherList = (params) => {
  return request({
    url: 'radioweb/app/web/getTeacherList',
    params,
    method: 'get'
  })
}
/**
 * 获取教师详情
 */
export const getTeacherDesc = (params) => {
  return request({
    url: 'radioweb/app/web/getTeacherDesc',
    params,
    method: 'get'
  })
}
/**
 * 获取教师详情
 */
export const getTeacherEsDesc = (params) => {
  return request({
    url: 'radioweb/app/web/getTeacherEsDesc',
    params,
    method: 'get'
  })
}
